import { TableDetailsItemOptionDto } from "../../services/tables/dto/table-details-dto";

export class TableItemOption {
  id: number;
  name: string;
  qty: number;
  value: number;
  tableOptionId: number;

  constructor(option: TableDetailsItemOptionDto) {
    this.id = option.id;
    this.name = option.name;
    this.qty = option.qty;
    this.value = option.value;
    this.tableOptionId = option.tableOptionId;
  }
}
